import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PartsAppointmentComponent } from './parts-appointment.component';
import { PartsAppointmentRoutingModule } from './parts-appointment-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { BdcSharedModule } from '../shared/bdc-shared.module';
import { ConfirmInfoComponentParts } from './confirm-info/confirm-info.component';

@NgModule({
  declarations: [PartsAppointmentComponent, ConfirmInfoComponentParts],
  imports: [
    CommonModule,
    PartsAppointmentRoutingModule,
    SharedModule,
    BdcSharedModule,
  ]
})
export class PartsAppointmentModule { }
